import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nowPage: null
  },
  mutations: {
    changePage(state, page) {
      state.nowPage = page;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js